import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-nav',
  template: `
    <nav class="navbar navbar-inverse navbar-fixed-top" (rmClickOutside)="closeNav()">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle"
                  [ngClass]="{'collapsed': !expanded}"
                  (click)="toggleNav()">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a (click)="closeNav()" class="navbar-brand" routerLink="/main" routerLinkActive="active">RON<strong>MARES</strong></a>
        </div>
        <div id="navbar" class="navbar-collapse collapse" [ngClass]="{'in': expanded}">
          <ul class="nav navbar-nav">
            <li routerLinkActive="active"><a (click)="closeNav()" routerLink="/main">Home</a></li>
            <li routerLinkActive="active"><a (click)="closeNav()" routerLink="/resume">Resume</a></li>
<!--            <li class="dropdown" [ngClass]="{'open': dropToggle}" routerLinkActive="active">-->
<!--              <a class="dropdown-toggle" (click)="toggleDropdown()">Examples <span class="caret"></span></a>-->
<!--              <ul class="dropdown-menu">-->
<!--&lt;!&ndash;                <li routerLinkActive="active"><a (click)="closeNav()" routerLink="/websites">Websites</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li routerLinkActive="active"><a (click)="closeNav()" routerLink="/javascript">JavaScript</a></li>&ndash;&gt;-->
<!--              </ul>-->
<!--            </li>-->
            <!--<li routerLinkActive="active"><a routerLink="/contact">Contact</a></li>-->
          </ul>
        </div>
      </div>
    </nav>
  `,
  styleUrls: ['nav.component.scss']
})
export class NavComponent implements OnInit {
  public dropToggle = false;
  public expanded = false;
  constructor() { }

  ngOnInit() {
  }

  toggleNav() {
    this.expanded = !this.expanded;
  }

  toggleDropdown() {
    this.dropToggle = !this.dropToggle;
  }

  closeNav() {
    this.expanded = false;
    this.dropToggle = false;
  }

  closeDropdown() {
    this.dropToggle = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/nav.component.ts